import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const InfoCol = styled.div`
  width: 50%;
  &:first-of-type {
    padding-right: 5px;
  }
  @media (max-width: ${breakpoints.bpDesktopPx}) {
    width: 100%;
    padding: 0;
    padding-top: 8px;
  }
`
export default InfoCol
